import { useState } from "react";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import Label from "../FormComponents/Label";
import TableTreeModal from "../BuilderComponents/TableTreeModal";
import Input from "../FormComponents/Input";

const EditFilePreview = ({ editElementData, setEditElementData, tableID }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSelectFile = (data) => {
    const copyData = JSON.parse(JSON.stringify(editElementData));
    copyData.preview_field = data;
    setEditElementData(copyData);
    setIsModalOpen(false);
  };

  const handleAllowShowPopup = ({ target: { checked, name } }) => {
    setEditElementData((prevData) => ({
      ...prevData,
      [name]: checked
    }));
  };

  return (
    <div>
      <div className="flex_column gap_2">
        <Label className="builder_label">Select Field</Label>
        <div className="builder_input d_flex justify_center cursor_pointer" onClick={() => setIsModalOpen(true)}>
          {!editElementData.preview_field
            ? "No field assign"
            : (editElementData.preview_field.activity_label || "") + "." + editElementData.preview_field.display}
        </div>
        <div className="field_horizontal_container">
          <Input
            type="checkbox"
            label="Allow Show Popup"
            name="allow_show_popup"
            checked={editElementData?.allow_show_popup || false} // The checkbox is now linked to showPopup state
            onChange={handleAllowShowPopup} // Toggles the visibility of the popup
          />
        </div>
      </div>

      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName="Select Field">
        <TableTreeModal
          callbackFunction={handleSelectFile}
          tableId={tableID}
          selectedFile={editElementData && editElementData?.preview_field && editElementData?.preview_field?.id}
        />
      </BuilderModal>
    </div>
  );
};

export default EditFilePreview;
